/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Meta_PersonalInputs */

const cs_social_hub_meta_personal = /** @type {(inputs: Social_Hub_Meta_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobní Meta`)
};

const en_social_hub_meta_personal = /** @type {(inputs: Social_Hub_Meta_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Meta`)
};

/**
* | output |
* | --- |
* | "Personal Meta" |
*
* @param {Social_Hub_Meta_PersonalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_meta_personal = /** @type {((inputs?: Social_Hub_Meta_PersonalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Meta_PersonalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_meta_personal(inputs)
	return cs_social_hub_meta_personal(inputs)
});